/**
 * Uppercases the first character of a string in a locale-aware way, leaving the
 * rest of the string untouched.
 *
 * @example
 * capitalizeFirst('detached houses average $1M', 'en') // "Detached houses average $1M"
 */
export function capitalizeFirst(text: string, locale?: string): string {
  if (!text) return text;
  return text.charAt(0).toLocaleUpperCase(locale) + text.slice(1);
}
